import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { GetIsFreeViewService } from '@/services/common/get-is-free-view.interface';
import { AccountInfoService } from '@/services/account-info/service/account-info.service.interface';
import { SiteRegion } from '@/services/account-info/type/account-info.enum';
import { PrimaryLang } from '../type/translation.enum';
import type { AITranslationOptions } from '../type/translation.type';

export const AITranslationOptionsService = Symbol('AITranslationOptionsService');

export interface AITranslationOptionsService {
    initialize: (patentLang: string) => AITranslationOptions;
}

const CONFIG_LIST = [
    { key: PrimaryLang.JP, lang: 'AIJP', label: '日本語 - AIpatent' },
    { key: PrimaryLang.EN, lang: 'AIEN', label: 'English - AIpatent' },
    { key: PrimaryLang.CN, lang: 'AICN', label: '简体中文 - AIpatent' },
];

const SUPPORTED_LANG_MAPPING = {
    [PrimaryLang.JP]: [PrimaryLang.CN, PrimaryLang.EN],
    [PrimaryLang.EN]: [PrimaryLang.JP],
    [PrimaryLang.CN]: [PrimaryLang.JP],
};

@injectable()
export class AITranslationOptionsServiceImpl implements AITranslationOptionsService {
    constructor(
        @inject(GetIsFreeViewService)
        private _getIsFree: GetIsFreeViewService,
        @inject(AccountInfoService)
        private _accountInfo: AccountInfoService,
    ) {
    }

    private _getPermission() {
        const isFree = this._getIsFree.getIsFreeView();
        const serviceArea = this._accountInfo.getModelData().site_region;
        return !isFree && (serviceArea === SiteRegion.CN);
    }

    private _getVisible(key: string, patentLang: string) {
        return this._getPermission() ?
            !!SUPPORTED_LANG_MAPPING[key].includes(patentLang)
            : false;
    }

    private _createListByConfig(patentLang: string) {
        return CONFIG_LIST
            .map(item => ({
                lang: item.lang,
                label: item.label,
                visible: this._getVisible(item.key, patentLang),
            }))
            .filter(item => item.visible)
            .map(item => ({ lang: item.lang, label: item.label }));
    }

    public initialize(lang: string) {
        return this._createListByConfig(lang);
    }
}
